import React from "react";

function CustomProgressBar(props) {
  const { completed, inProgress, total } = props;

  function isWhatPercentOf(numA, numB) {
    numA = Number(numA);
    numB = Number(numB);
    return Math.floor((numA / numB) * 100);
  }

  return (
    <div className="mb-[3px] flex w-full bg-gray-300 rounded-full dark:bg-gray-300 overflow-hidden">
      {!completed && !inProgress && (
        <div
          className={`text-[10px] font-medium text-blue-100 text-center p-0.5 leading-none transition-all duration-500`}
          style={{
            width: `${isWhatPercentOf(completed, total)}%`,
            minWidth: "max-content",
          }}>
          {isWhatPercentOf(completed, total)}%
        </div>
      )}
      {completed > 0 && (
        <div
          className={`bg-green-500 text-[10px] font-medium text-blue-100 text-center p-0.5 leading-none transition-all duration-500`}
          style={{
            width: `${isWhatPercentOf(completed, total)}%`,
            minWidth: "max-content",
          }}>
          {isWhatPercentOf(completed, total)}%
        </div>
      )}
      {inProgress > 0 && (
        <div
          className="min-h-max  text-[10px] bg-yellow-500 text-xs font-medium text-blue-100 text-center p-0.5 leading-none transition-all duration-500"
          style={{
            width: `${isWhatPercentOf(inProgress, total)}%`,
            minHeight: "max-content",
            minWidth: "max-content",
          }}>
          {isWhatPercentOf(inProgress, total)}%
        </div>
      )}
    </div>
  );
}

export default CustomProgressBar;
